import { ApiClientData } from "../../../libs/firebase/ApiClientData";
import { Utilities } from "../../../utils/utilities";
import { UserData } from "../User/UserData";
import { LocalData } from "./LocalData";

export class CreatedByData {
  user?: UserData;
  date?: Date;
  apiClient?: ApiClientData;
  workflowID?: string;
  source?: CreatedBySource;

  constructor(data: { [key: string]: any }) {
    if (Utilities.isValidString(data.userID)) {
      this.user = LocalData.users.addData(data.userID);
    }

    const date = Utilities.getDateFromTimestamp(data.date);
    if (date) this.date = date;

    if (typeof data.apiClient?.id === "string") {
      this.apiClient = LocalData.apiClients.addData(data.apiClient.id);
    }
    if (typeof data.workflowID === "string") {
      this.workflowID = data.workflowID;
    }
    if (typeof data.source === "string") {
      this.source = data.source as CreatedBySource;
    }
  }
}

export type CreatedBySource = "workflow" | "user" | "ai" | "api" | "email";
